import React, { useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Capabilities from "./pages/Capabilities";
import Quote from "./pages/Quote";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";

// SPA navigation doesn't reset scroll or follow #hash links on its own.
function ScrollManager() {
	const { pathname, hash } = useLocation();
	useEffect(() => {
		if (hash) {
			// wait one frame so the target section is rendered
			requestAnimationFrame(() => {
				const el = document.getElementById(hash.slice(1));
				if (el) el.scrollIntoView();
			});
		} else {
			window.scrollTo(0, 0);
		}
	}, [pathname, hash]);
	return null;
}

export default function App() {
	return (
		<>
			<ScrollManager />
			<Header />
			<main id="main">
				<Routes>
					<Route path="/" element={<Home />} />
					{/* /services is the existing URL — kept so search rankings and old links still work */}
					<Route path="/services" element={<Capabilities />} />
					<Route path="/capabilities" element={<Navigate to="/services" replace />} />
					<Route path="/quote" element={<Quote />} />
					<Route path="/privacy" element={<Privacy />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
			</main>
			<Footer />
		</>
	);
}
